import ACIndicadorReportSummary from "./ACIndicadorReportSummary";

export default async function ACReportSummary(indicador, visita, tipoName) {
    const IndicadorClass = indicador.constructor;

    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null;
    }

    return ACIndicadorReportSummary(indicador, visita, tipoName, params);
}

